module.exports = "/shifts/directives/user-aggregated-event-35f3f0.html";